import React from "react";

type Props = {
    title?: string;
    alt?: string;
    borderRadius?: string;
    height?: string;
    width?: string;
    isBackground?: boolean;
    backgroundPosition?: string;
    imgStyleProps?: React.CSSProperties;
    backgroundSize?: string;
    displayCaption?: boolean;
    captionPosition?: "top" | "bottom";
    caption?: string;
    children?: React.ReactNode;
    src: string;
    fadeIn?: boolean;
    className?: string;
};

const ImageFormatter = ({
                            title,
                            alt,
                            borderRadius,
                            height = "280px",
                            width = "100%",
                            isBackground,
                            backgroundPosition = "center",
                            backgroundSize = "cover",
                            imgStyleProps,
                            displayCaption = false,
                            captionPosition = "bottom",
                            caption,
                            src,
                            children,
                            fadeIn,
                            className,
                        }: Props) => {
    const imgStyle: React.CSSProperties = {
        height,
        width,
        backgroundPosition,
        backgroundSize,
        borderRadius: borderRadius || "0",
        backgroundImage: `url(${src})`,
        backgroundRepeat: "no-repeat",
        position: children ? "relative" : "inherit",
        ...imgStyleProps,
    };

    return (
        <div className="relative">
            {isBackground ? (
                <div
                    style={imgStyle}
                    className={`
                        ${fadeIn ? "animate-fadeIn" : ""}
                        ${className || ""}
                    `}
                >
                    {children}
                </div>
            ) : (
                <img
                    src={src}
                    title={title}
                    alt={alt}
                    loading="lazy"
                    // height={height}
                    // width={width}
                    className={`
                                w-full h-full object-cover   
                                ${fadeIn ? "animate-fadeIn" : ""}
                                ${className || ""}
                              `}
                />
            )}

            {displayCaption && caption && (
                <div
                    className={`
                        absolute left-0 right-0 
                        ${captionPosition === "top" ? "top-0" : "bottom-0"}
                        p-2 bg-white/70 text-black text-xs
                    `}
                >
                    {caption}
                </div>
            )}
        </div>
    );
};

export default ImageFormatter;
